import { createFrontendModule } from "@backstage/frontend-plugin-api";
import {
    createFormField,
    FormFieldBlueprint,
} from "@backstage/plugin-scaffolder-react/alpha";

import { EnvironmentsAppSelectFieldExtension } from "./components";

const EnvironmentsAppSelectExtension = FormFieldBlueprint.make({
    name: "environments-app-select",
    params: {
        field: async () =>
            createFormField({
                name: "EnvironmentsAppSelect",
                component: EnvironmentsAppSelectFieldExtension,
            }),
    },
});

const scaffolderModuleEnvironmentsAppSelect = createFrontendModule({
    pluginId: "scaffolder",
    extensions: [EnvironmentsAppSelectExtension],
});

export default scaffolderModuleEnvironmentsAppSelect;
